module.exports = __webpack_public_path__ + "static/media/Golos_Text_DemiBold.9bc84b72.woff";